import type { SvgIconComponent } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";

interface Props {
  Icon?: SvgIconComponent;
  label: string;
  labelWidth: string | number;
  value: string | React.ReactNode;
}

const InlineAttribute = ({ Icon, label, labelWidth, value }: Props) => {
  return (
    <Stack spacing={1.5} direction="row" sx={{ alignItems: "center", py: 1 }}>
      <Stack spacing={1.5} direction="row" sx={{ alignItems: "center", width: labelWidth, minWidth: labelWidth }}>
        {Icon && <Icon color="action" />}
        <Typography color="textSecondary">{label}</Typography>
      </Stack>
      {typeof value === "string" ? <Typography>{value}</Typography> : value}
    </Stack>
  );
};

export default InlineAttribute;
